/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

const uuidV4 = require('uuid/v4');

angular.module('FlexyBeautyApp.services').
    factory('Sale_Resource',["$resource","$location", function ($resource,$location)
    {
        var resourceBooking;
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        resourceBooking = $resource(baseUrl + 'rest/sales/:date/:id', {}, {
            query: { method: 'GET', isArray: true },
            get: { method: 'GET' },
            saveTransaction :  { method: 'POST', url: baseUrl + 'rest/sales/saveTransaction'},
            refund :  { method: 'POST', url: baseUrl + 'rest/sales/refund/:id'},
            sendMails :  { method: 'POST', url: baseUrl + 'rest/sales/sendMails/:id'}
        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Sale', ["SaleData","Payment","SaleService","SaleProduct","SaleCure","CustomerData","BookingData","GiftItem","GiftItemData","OtherPaymentTypeData",
        "LoyaltyCardItem","LoyaltyCardItemData","CheckDepositData","HumanResourceData",
        function (SaleData, Payment, SaleService, SaleProduct, SaleCure, CustomerData, BookingData, GiftItem, GiftItemData, OtherPaymentTypeData,
                  LoyaltyCardItem, LoyaltyCardItemData, CheckDepositData, HumanResourceData) {
            var Sale = function (saleRes, day, mustloadElements, isPreviousVersion, isApplicationLoading) {
                this.id = null;
                this.requestId = null;
                this.isDeleted = false;
                this.booking = null;
                this._bookingId = null;
                this.customer = null;
                this.customerLastname = null;
                this.customerFirstname = null;
                this.customerAddress = null;
                this.customerZip = null;
                this.customerCity = null;
                this.shareCapital = null;
                this.greffeCity = null;
                this.juridicForm = null;
                this._customerId = null;  //tmp for loading only
                this.oriSale = null;
                this._oriSaleId = null;  //tmp for loading only
                this.saleNumber = null;
                this.advanceNumber = null;
                this.estimationNumber = null;
                this.signatureCode = null;
                this.canceledSaleNumber = null;
                this.day = null;
                this.timeCreated = null;
                this.vat = 0;
                this.vatCode = null;
                this.servicesPrice = 0;
                this.productsPrice = 0;
                this.curesPrice = 0;
                this.giftItemsPrice = 0;
                this.loyaltyCardsPrice = 0;
                this.price = 0;
                this.priceHT = 0;
                this.statusType = {
                    created: "created",
                    waiting: "waiting",
                    sold: "sold",
                    canceled: "canceled",
                    credit: "credit",
                    advance: "advance"
                };
                this.status = this.statusType.created;
                this.delivery = null;
                this.deliveryMsg = null;
                this.techNote = null;
                this.comment = null;
                // Default value
                this.isCreatedByCustomer = false;
                this.cancelReason = "";
                // Payment type
                this.payments = [];
                this.categoryTypes = {
                    product: "product",
                    service: "service",
                    cure: "cure",
                    giftItem: "giftItem",
                    loyaltyCard: "loyaltyCard"
                };
                this.saleServices = [];
                this.saleProducts = [];
                this.saleCures = [];
                this.giftItems = [];
                this.loyaltyCardItems = [];
                this.discountPercent = 0;
                // onlinePayment
                this.paymentCardId = null;
                this.loyaltyCardItem = null;
                this._loyaltyCardItemId = null;
                this.hasLoyaltyDiscount = false;
                this.nbPrint = 0;
                this.hrSeller = null;
                this.hrOp = null;
                this.loyaltyPts = 0;
                this.version = null;
                // local data
                this.realPaidPrice = 0;
                // local data
                this.caPrice = 0;
                this.sendByMail = false;
                this.sendGiftByMail = false;
                this.softV = null;
                this.deviceType = "DESKTOP";
                this.totalLoyaltyPts = 0;
                this.advancePrice = 0;
                this.site = null;

                if (saleRes!==undefined && saleRes!=null)
                {
                    this.loadObjectProperties(saleRes);
                    if (mustloadElements) {
                        this.loadObjectSaleServices(saleRes);
                        this.loadObjectSaleProducts(saleRes);
                        this.loadObjectSaleCures(saleRes);
                        this.loadObjectGiftItems(saleRes, isApplicationLoading);
                        this.loadObjectLoyaltyCardItems(saleRes);
                    }
                }
                else
                    this.requestId = uuidV4();

                if (day!==undefined && day!=null)
                    this.day = day;

                if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
                    SaleData.add(this, isApplicationLoading);
            };

            Sale.prototype.loadObjectProperties = function(object) {
                if (object)
                {
                    if (!this.id)
                        this.id =  object.id;
                    this.requestId =  object.requestId;
                    this.saleNumber = object.saleNumber;
                    this.advanceNumber = object.advanceNumber;
                    this.estimationNumber = object.estimationNumber;
                    this.signatureCode = object.signatureCode;
                    this.canceledSaleNumber = object.canceledSaleNumber;
                    this._customerId=object.customerId;
                    this._bookingId=object.bookingId;
                    this._oriSaleId = object.oriSaleId;
                    if (object.timeCreated)
                        this.timeCreated = new Date(object.timeCreated);
                    this.status = object.status;
                    this.delivery = object.delivery;
                    this.deliveryMsg = object.deliveryMsg;
                    this.techNote = object.techNote;
                    this.comment = object.comment;
                    this.isCreatedByCustomer = object.isCreatedByCustomer;
                    this.nbPrint =  object.nbPrint;
                    this.cancelReason = object.cancelReason;
                    this.vat = object.vat;
                    this.vatCode = object.vatCode;
                    this.servicesPrice = object.servicesPrice;
                    this.productsPrice = object.productsPrice;
                    if (object.curesPrice != undefined)
                        this.curesPrice = object.curesPrice;
                    if (object.giftItemsPrice != undefined)
                        this.giftItemsPrice = object.giftItemsPrice;
                    if (object.loyaltyCardsPrice != undefined)
                        this.loyaltyCardsPrice = object.loyaltyCardsPrice;
                    this.price = object.price;
                    this.priceHT = object.priceHT;
                    this.discountPercent = object.discountPercent;
                    this.payments = [];
                    if (object.payments)
                        for (var i=0;i<object.payments.length;i++)
                            this.payments.push(new Payment(object.payments[i]));
                    this.updateRealPaymentPrice();
                    this.loyaltyPts = object.loyaltyPts;
                    this.loyaltyDate = object.loyaltyDate;
                    this._loyaltyCardItemId = object.loyaltyCardItemId;
                    if (object.hrSellerId!==undefined)
                        this.hrSeller = HumanResourceData.getById(object.hrSellerId);
                    if (object.hrOpId!==undefined)
                        this.hrOp = HumanResourceData.getById(object.hrOpId);
                    if (object.version)
                        this.version = object.version;
                    this.softV = object.softV;
                    this.totalLoyaltyPts = object.totalLoyaltyPts;
                    this.site = object.site;
                    this.hasLoyaltyDiscount = object.hasLoyaltyDiscount;
                    this.advancePrice = object.advancePrice;
                    if(object.deviceType)
                        this.deviceType = object.deviceType;
                    this.customerLastname = object.customerLastname;
                    this.customerFirstname = object.customerFirstname;
                    this.customerAddress = object.customerAddress;
                    this.customerZip = object.customerZip;
                    this.customerCity = object.customerCity;
                    this.shareCapital = object.shareCapital;
                    this.greffeCity = object.greffeCity;
                    this.juridicForm = object.juridicForm;
                }
            };

            Sale.prototype.loadObjectSaleServices = function (object) {
                if (object.saleServices) {
                    this.saleServices = [];
                    for (let oneSaleService of object.saleServices) {
                        if (!oneSaleService.saleId || oneSaleService.saleId === this.id) {
                            this.addSaleService(new SaleService(oneSaleService));
                        }
                    }
                }
            };

            Sale.prototype.loadObjectSaleProducts = function (object) {
                if (object.saleProducts) {
                    this.saleProducts = [];
                    for (let oneSaleProduct of object.saleProducts) {
                        if (!oneSaleProduct.saleId || oneSaleProduct.saleId === this.id) {
                            this.addSaleProduct(new SaleProduct(oneSaleProduct));
                        }
                    }
                }
            };

            Sale.prototype.loadObjectSaleCures = function (object) {
                if (object.saleCures) {
                    this.saleCures = [];
                    for (let oneSaleCure of object.saleCures) {
                        if (!oneSaleCure.saleId || oneSaleCure.saleId === this.id) {
                            this.addSaleCure(new SaleCure(oneSaleCure, true));
                        }
                    }
                }
            };

            Sale.prototype.loadObjectGiftItems = function (object, isApplicationLoading) {
                if (object.giftItems) {
                    this.giftItems = [];
                    for (let oneGiftItem of object.giftItems) {
                        if (!oneGiftItem.saleId || oneGiftItem.saleId === this.id) {
                            let giftItem = GiftItemData.getById(oneGiftItem.id);
                            if (!giftItem) {
                                giftItem = new GiftItem(oneGiftItem, null, isApplicationLoading);
                            }
                            this.addGiftItem(giftItem);
                        }
                    }
                }
            };

            Sale.prototype.loadObjectLoyaltyCardItems = function(object) {
                if (object.loyaltyCardItems) {
                    this.loyaltyCardItems = [];
                    for (let oneLoyaltyCardItem of object.loyaltyCardItems) {
                        if (!oneLoyaltyCardItem.saleId || oneLoyaltyCardItem.saleId === this.id) {
                            this.addLoyaltyCardItem(new LoyaltyCardItem(oneLoyaltyCardItem));
                        }
                    }
                }
            };

            Sale.prototype.loadObject = function(object, isApplicationLoading) {
                this.loadObjectProperties(object);
                this.loadObjectSaleServices(object);
                this.loadObjectSaleProducts(object);
                this.loadObjectSaleCures(object);
                this.loadObjectGiftItems(object, isApplicationLoading);
                this.loadObjectLoyaltyCardItems(object);
            };

            Sale.prototype.loadRef = function(isPreviousVersion, isApplicationLoading) {
                if (this._customerId && (!this.customer || !isApplicationLoading)) {
                    this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
                    if (this.customer && (isPreviousVersion===undefined || !isPreviousVersion)) {
                        this.customer.addSale(this);
                    }
                }
                if (this._oriSaleId && (!this.oriSale || !isApplicationLoading)) {
                    this.oriSale = SaleData.getById(this._oriSaleId, isApplicationLoading);
                }

                if (this._bookingId && (!this.booking || !isApplicationLoading)) {
                    this.booking =  BookingData.getById(this._bookingId);
                    if (this.booking && !this.booking.sale && (this.status == this.statusType.sold || this.status == this.statusType.waiting)) {
                        this.booking.sale = this;
                    }
                }

                for (var i = 0; i < this.payments.length; i++) {
                    if (this.payments[i]._giftItemId) {
                        this.payments[i].giftItem = GiftItemData.getById(this.payments[i]._giftItemId);
                        if (this.payments[i].giftItem && this.status != this.statusType.canceled
                            && this.status != this.statusType.credit) {
                            this.payments[i].giftItem.paymentSale = this;
                        }
                    }
                    if (this.payments[i]._otherPaymentTypeId) {
                        this.payments[i].otherPaymentType = OtherPaymentTypeData.getById(this.payments[i]._otherPaymentTypeId);
                    }
                    if (this.payments[i]._checkDepositId) {
                        this.payments[i].checkDeposit = CheckDepositData.getById(this.payments[i]._checkDepositId);
                        if (this.payments[i].checkDeposit) {
                            this.payments[i].checkDeposit.addSalePayment(this,this.payments[i]);
                        }
                    }
                }

                if (this.loyaltyCardItems) {
                    for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                        this.loyaltyCardItems[i].loadRef(null, isApplicationLoading);
                    }
                }
                if (this._loyaltyCardItemId && (!this.loyaltyCardItem || !isApplicationLoading)) {
                    this.loyaltyCardItem = LoyaltyCardItemData.getById(this._loyaltyCardItemId);
                }
            };

            Sale.prototype.updateRealPaymentPrice = function() {
                this.realPaidPrice = 0;
                for (var i = 0; i < this.payments.length; i++) {
                    if (this.payments[i].type != "UNPAID" && this.payments[i].type != "GIFT") {
                        this.realPaidPrice += this.payments[i].price;
                    }
                }
            };

            Sale.prototype.getObjectResource = function() {
                var saleRes = {};
                //customer = booking.customer when booking is saved.
                saleRes.id = this.id;
                saleRes.requestId = this.requestId;
                saleRes.saleNumber = this.saleNumber;
                saleRes.advanceNumber = this.advanceNumber;
                saleRes.estimationNumber = this.estimationNumber;
                saleRes.canceledSaleNumber = this.canceledSaleNumber;
                if (this.day)
                    saleRes.dayId = this.day.id;
                if (this.customer)//always save it
                    saleRes.customer = this.customer.getObjectResource();
                if (this.booking) {//always save it
                    saleRes.bookingId = this.booking.id;
                }
                if (this.oriSale)//always save it
                    saleRes.oriSaleId = this.oriSale.id;

                saleRes.vat = this.vat;
                saleRes.vatCode = this.vatCode;
                saleRes.servicesPrice = this.servicesPrice;
                saleRes.productsPrice = this.productsPrice;
                saleRes.curesPrice = this.curesPrice;
                saleRes.giftItemsPrice = this.giftItemsPrice;
                saleRes.loyaltyCardsPrice = this.loyaltyCardsPrice;
                saleRes.price = this.price;
                saleRes.priceHT = this.priceHT;
                saleRes.status = this.status;
                saleRes.delivery = this.delivery;
                saleRes.deliveryMsg = this.deliveryMsg;
                saleRes.techNote = this.techNote;
                saleRes.comment = this.comment;
                saleRes.isCreatedByCustomer = this.isCreatedByCustomer;
                saleRes.nbPrint = this.nbPrint;
                saleRes.cancelReason = this.cancelReason;
                saleRes.discountPercent = this.discountPercent;
                saleRes.sendByMail = this.sendByMail;
                saleRes.sendGiftByMail = this.sendGiftByMail;
                saleRes.deviceType = this.deviceType;
                saleRes.totalLoyaltyPts = this.totalLoyaltyPts;
                saleRes.hasLoyaltyDiscount = this.hasLoyaltyDiscount;
                if (this.hrSeller)
                    saleRes.hrSellerId = this.hrSeller.id;
                if (this.hrOp)
                    saleRes.hrOpId = this.hrOp.id;

                saleRes.payments = [];
                for (var i=0;i<this.payments.length;i++)
                    saleRes.payments.push(this.payments[i].getObjectResource());

                saleRes.saleServices=[];
                for (var i=0;i< this.saleServices.length;i++){
                    saleRes.saleServices.push(this.saleServices[i].getObjectResource());
                }
                saleRes.saleProducts=[];
                for (var i=0;i< this.saleProducts.length;i++){
                    saleRes.saleProducts.push(this.saleProducts[i].getObjectResource());
                }
                saleRes.saleCures=[];
                for (var i=0;i< this.saleCures.length;i++){
                    saleRes.saleCures.push(this.saleCures[i].getObjectResource());
                }
                saleRes.giftItems=[];
                for (var i=0;i< this.giftItems.length;i++){
                    saleRes.giftItems.push(this.giftItems[i].getObjectResource());
                }
                saleRes.loyaltyCardItems=[];
                for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                    saleRes.loyaltyCardItems.push(this.loyaltyCardItems[i].getObjectResource());
                }

                saleRes.paymentCardId = this.paymentCardId;
                saleRes.loyaltyPts = this.loyaltyPts;
                saleRes.loyaltyDate = this.loyaltyDate;
                saleRes.advancePrice = this.advancePrice;
                if (this.loyaltyCardItem)
                    saleRes.loyaltyCardItemId = this.loyaltyCardItem.id;

                saleRes.customerLastname = this.customerLastname;
                saleRes.customerFirstname = this.customerFirstname;
                saleRes.customerAddress = this.customerAddress;
                saleRes.customerZip = this.customerZip;
                saleRes.customerCity = this.customerCity;
                saleRes.shareCapital = this.shareCapital;
                saleRes.greffeCity = this.greffeCity;
                saleRes.juridicForm = this.juridicForm;

                return saleRes;
            };

            Sale.prototype.addSaleService = function(saleService) {
                var index =  this.saleServices.indexOf(saleService);
                if (index==-1)
                {
                    this.saleServices.push(saleService);
                    saleService.sale = this;
                }
            };

            Sale.prototype.removeSaleService = function(saleService) {
                if (saleService!=null)
                {
                    var index =  this.saleServices.indexOf(saleService);
                    if (index!=-1)
                        this.saleServices.splice(index,1);
                    saleService.sale = null;
                }

            };

            Sale.prototype.getSaleProductById = function(id) {
                for (var i=0; i< this.saleProducts.length;i++)
                    if (this.saleProducts[i].id==id)
                        return this.saleProducts[i];
                return null;
            };

            Sale.prototype.addSaleProduct = function(saleProduct) {
                var index =  this.saleProducts.indexOf(saleProduct);
                if (index==-1)
                {
                    this.saleProducts.push(saleProduct);
                    saleProduct.sale = this;
                }
            };

            Sale.prototype.removeSaleProduct = function(saleProduct) {
                if (saleProduct!=null)
                {
                    var index =  this.saleProducts.indexOf(saleProduct);
                    if (index!=-1)
                        this.saleProducts.splice(index,1);
                    saleProduct.sale = null;
                }

            };

            Sale.prototype.getSaleCureById = function(id) {
                for (var i=0; i< this.saleCures.length;i++)
                    if (this.saleCures[i].id==id)
                        return this.saleCures[i];
                return null;
            };

            Sale.prototype.addSaleCure = function(saleCure) {
                var index =  this.saleCures.indexOf(saleCure);
                if (index==-1)
                {
                    this.saleCures.push(saleCure);
                    saleCure.sale = this;
                }
            };

            Sale.prototype.removeSaleCure = function(saleCure) {
                if (saleCure!=null)
                {
                    var index =  this.saleCures.indexOf(saleCure);
                    if (index!=-1)
                        this.saleCures.splice(index,1);
                    saleCure.sale = null;
                }

            };

            Sale.prototype.addGiftItem = function(giftItem) {
                var index =  this.giftItems.indexOf(giftItem);
                if (index==-1)
                {
                    this.giftItems.push(giftItem);
                    giftItem.sale = this;
                }
            };

            Sale.prototype.removeGiftItem = function(giftItem) {
                if (giftItem!=null)
                {
                    var index =  this.giftItems.indexOf(giftItem);
                    if (index!=-1)
                        this.giftItems.splice(index,1);
                    giftItem.sale = null;
                }
            };

            Sale.prototype.addLoyaltyCardItem = function(loyaltyCardItem) {
                var index = this.loyaltyCardItems.indexOf(loyaltyCardItem);
                if (index == -1) {
                    this.loyaltyCardItems.push(loyaltyCardItem);
                    loyaltyCardItem.sale = this;
                }
            };

            Sale.prototype.removeLoyaltyCardItem = function(loyaltyCardItem) {
                if (loyaltyCardItem != null) {
                    var index = this.loyaltyCardItems.indexOf(loyaltyCardItem);
                    if (index != -1) {
                        this.loyaltyCardItems.splice(index, 1);
                    }
                    loyaltyCardItem.sale = null;
                }
            };

            Sale.prototype.isStatusSoldOrCreditOrCanceled = function() {
                return this.status == this.statusType.sold
                    || this.status == this.statusType.credit || this.status == this.statusType.canceled;
            };

            Sale.prototype.getSaleCuresSumPrice = function() {
                var price = 0;
                if (this.isStatusSoldOrCreditOrCanceled()) {
                    for (var i = 0; i < this.saleCures.length; i++) {
                        price += this.saleCures[i].getDiscountPrice();
                    }
                }
                return price;
            };

            Sale.prototype.getLoyaltyCardItemsSumPrice = function() {
                var price = 0;
                if (this.isStatusSoldOrCreditOrCanceled()) {
                    for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                        price += this.loyaltyCardItems[i].getDiscountPrice();
                    }
                }
                return price;
            };

            Sale.prototype.applyGlobalDiscountAndGift = function(price,withGift) {
                var discountPercentForItems = this.discountPercent;
                if (!withGift) //Remove gift payment from price
                {
                    var originalPrice =  this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
                    var paymentGift = 0;
                    for (var j = 0; j < this.payments.length; j++)
                        if (this.payments[j].type == "GIFT")
                            paymentGift += this.payments[j].price;
                    if (originalPrice > 0)
                        discountPercentForItems =  (100 - 100 * (this.price - paymentGift) / originalPrice);
                }
                //apply global discount on price
                if (discountPercentForItems == 0)
                    return price;
                else
                    return price - discountPercentForItems*price/100;
            };

            Sale.prototype.getSaleServicesSumPriceByHrId = function(hrId, withGift) {
                var price = 0;
                if (this.isStatusSoldOrCreditOrCanceled())
                {
                    for (var i=0;i< this.saleServices.length;i++)
                    {
                        if(this.saleServices[i].subSaleServices.length != 0)
                        {
                            for(var j = 0; j < this.saleServices[i].subSaleServices.length; j++)
                            {
                                if(this.saleServices[i].subSaleServices[j].humanResource && this.saleServices[i].subSaleServices[j].humanResource.id == hrId)
                                {
                                    price += this.saleServices[i].subSaleServices[j].price;
                                }
                            }
                        }
                        else
                        {
                            if ((this.saleServices[i].humanResource && this.saleServices[i].humanResource.id == hrId) || (!this.saleServices[i].humanResource && !hrId))
                            {
                                price += this.saleServices[i].price;
                            }
                        }
                    }
                    price = this.applyGlobalDiscountAndGift(price,withGift);
                }
                return price;
            };

            /**
             * Check if a sale exist with an item id (serviceId, productId, cureId, ...)
             * and the category type (service, product, cure, ...).
             *
             * @param itemId the itemId
             * @param categoryType the categoryType
             *
             * return boolean
             */
            Sale.prototype.hasItemByIdAndType = function(itemId, categoryType) {
                if (this.isStatusSoldOrCreditOrCanceled()) {
                    switch (categoryType) {
                        case this.categoryTypes.service:
                            return this.saleServices.some( (element) => element.service && element.service.id == itemId);
                        case this.categoryTypes.product:
                            return this.saleProducts.some( (element) => element.product && element.product.id == itemId);
                        case this.categoryTypes.cure:
                            return this.saleCures.some( (element) => element.cure && element.cure.id == itemId);
                        case this.categoryTypes.giftItem:
                            return this.giftItems.some( (element) => element.id == itemId);
                        case this.categoryTypes.loyaltyCard:
                            return this.loyaltyCardItems.some( (element) => element.loyaltyCard && element.loyaltyCard.id == itemId);
                        default:
                            return false;
                    }
                }
                return false;
            };

            Sale.prototype.getSaleProductsSumPriceByHrId = function(hrId, withGift) {
                var price = 0;
                if (this.isStatusSoldOrCreditOrCanceled())
                {
                    for (var i=0; i< this.saleProducts.length;i++)
                        if ( (this.saleProducts[i].humanResource && this.saleProducts[i].humanResource.id == hrId)
                            || (!this.saleProducts[i].humanResource && !hrId) )
                            price +=  this.saleProducts[i].price;
                    //apply global discount on price
                    price = this.applyGlobalDiscountAndGift(price,withGift);
                }
                return price;
            };

            Sale.prototype.getSaleGiftItemsSumPriceByHrId = function(hrId,withGift) {
                var price = 0;
                if (this.isStatusSoldOrCreditOrCanceled())
                {
                    for (var i=0; i< this.giftItems.length;i++)
                        if ((this.giftItems[i].humanResource && this.giftItems[i].humanResource.id == hrId)||(!this.giftItems[i].humanResource && !hrId))
                            price +=  this.giftItems[i].price;
                    //apply global discount on price
                    price = this.applyGlobalDiscountAndGift(price,withGift);
                }
                return price;
            };

            Sale.prototype.getSaleCuresSumPriceByHrId = function(hrId, withGift) {
                var price = 0;
                if (this.isStatusSoldOrCreditOrCanceled()) {
                    for (var i = 0; i < this.saleCures.length; i++) {
                        if ((this.saleCures[i].humanResource && this.saleCures[i].humanResource.id == hrId)
                            || (!this.saleCures[i].humanResource && !hrId)) {
                            price += this.saleCures[i].price;
                        }
                    }
                    //apply global discount on price
                    price = this.applyGlobalDiscountAndGift(price,withGift);
                }
                return price;
            };

            Sale.prototype.getLoyaltyCardItemsSumPriceByHrId = function(hrId, withGift) {
                var price = 0;
                if (this.isStatusSoldOrCreditOrCanceled()) {
                    for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                        if ((this.loyaltyCardItems[i].humanResource && this.loyaltyCardItems[i].humanResource.id == hrId)
                            || (!this.loyaltyCardItems[i].humanResource && !hrId)) {
                            price += this.loyaltyCardItems[i].price;
                        }
                    }
                    price = this.applyGlobalDiscountAndGift(price, withGift);
                }
                return price;
            };

            Sale.prototype.getSalesServicesByHrId = function(hrId) {
                var salesItems = [];
                if (this.isStatusSoldOrCreditOrCanceled())
                {
                    for (var i = 0;i < this.saleServices.length;i++) {
                        if(this.saleServices[i].subSaleServices.length != 0){
                            for(var j = 0; j < this.saleServices[i].subSaleServices.length; j++){
                                if (this.saleServices[i].subSaleServices[j].humanResource && this.saleServices[i].subSaleServices[j].humanResource.id == hrId){
                                    salesItems.push(this.saleServices[i].subSaleServices[j]);
                                }
                            }
                        }
                        else{
                            if (this.saleServices[i].humanResource && this.saleServices[i].humanResource.id == hrId)
                                salesItems.push(this.saleServices[i]);
                        }
                    }

                }
                return salesItems;
            };

            Sale.prototype.getSalesProductsByHrId = function(hrId) {
                var salesItems = [];
                if (this.isStatusSoldOrCreditOrCanceled())
                {
                    for (var i=0; i< this.saleProducts.length;i++)
                        if (this.saleProducts[i].humanResource && this.saleProducts[i].humanResource.id == hrId)
                            salesItems.push(this.saleProducts[i]);
                    for (var i=0; i< this.saleCures.length;i++)
                        if (this.saleCures[i].humanResource && this.saleCures[i].humanResource.id == hrId)
                            salesItems.push(this.saleCures[i]);
                    for (var i=0; i< this.giftItems.length;i++)
                        if (this.giftItems[i].humanResource && this.giftItems[i].humanResource.id == hrId)
                            salesItems.push(this.giftItems[i]);
                    for (var i=0; i< this.loyaltyCardItems.length;i++)
                        if (this.loyaltyCardItems[i].humanResource && this.loyaltyCardItems[i].humanResource.id == hrId)
                            salesItems.push(this.loyaltyCardItems[i]);
                }
                return salesItems;
            };

            Sale.prototype.hasPaymentType = function(type) {
                for (var i=0; i < this.payments.length; i++) {
                    if (this.payments[i].type == type) {
                        return true;
                    }
                }
                return false;
            };

            Sale.prototype.hrIsWorking = function(hrId) {
                var hrIsWorking = false;
                for (var i = 0; i < this.saleServices.length; i++) {
                    if(this.saleServices[i].subSaleServices.length == 0) {
                        if (this.saleServices[i].humanResource && this.saleServices[i].humanResource.id === hrId) {
                            return true;
                        }
                    }
                    else{
                        for(var j = 0; j < this.saleServices[i].subSaleServices.length; j++){
                            if (this.saleServices[i].subSaleServices[j].humanResource && this.saleServices[i].subSaleServices[j].humanResource.id === hrId) {
                                return true;
                            }
                        }
                    }
                }
                for (var i = 0; i < this.saleProducts.length; i++) {
                    if(this.saleProducts[i].humanResource && this.saleProducts[i].humanResource.id === hrId){
                        return true;
                    }
                }
                for (var i = 0; i < this.saleCures.length; i++) {
                    if(this.saleCures[i].humanResource && this.saleCures[i].humanResource.id === hrId){
                        return true;
                    }
                }
                for (var i = 0; i < this.loyaltyCardItems.length; i++) {
                    if(this.loyaltyCardItems[i].humanResource && this.loyaltyCardItems[i].humanResource.id === hrId){
                        return true;
                    }
                }

                return hrIsWorking;
            };

            Sale.prototype.getAllItemsPrice = function(){
                let allItemPrice = 0;
                if (this.booking && (this.status === "created" || this.status === "waiting" || this.status === "advance" || this.status === "soldProcess"|| this.status === "advanceProcess"))
                    for (let i=0; i< this.booking.bookingServices.length;i++)
                        allItemPrice += this.booking.bookingServices[i].price;
                else
                    for (let i=0; i< this.saleServices.length;i++)
                        allItemPrice += this.saleServices[i].price;
                for (let i=0; i< this.saleProducts.length;i++)
                    allItemPrice += this.saleProducts[i].price;
                for (let i=0; i< this.saleCures.length;i++)
                    allItemPrice += this.saleCures[i].price;
                for (let i=0; i< this.giftItems.length;i++)
                    allItemPrice += this.giftItems[i].price;
                for (let i=0; i< this.loyaltyCardItems.length;i++)
                    allItemPrice += this.loyaltyCardItems[i].price;

                return allItemPrice;
            };

            Sale.prototype.isCancelledOrCredit = function() {
                return (this.status === 'canceled' || this.status === 'credit');
            };

            Sale.prototype.hasReceivedPayment = function() {
                return (this.status==="sold" || this.status==="advance" || this.status==="advanceKeeped");
            };

            Sale.prototype.inactiveUnusedLoyaltyCardItem = function(activeLoyaltyCard){
                if(this.loyaltyCardItem && !this.loyaltyCardItem.isUsed && activeLoyaltyCard){
                    this.loyaltyCardItem.isUsed = true;
                }
            };

            Sale.prototype.inactiveUnusedLoyaltyCardItems = function(activeLoyaltyCard){
                if(this.loyaltyCardItems && activeLoyaltyCard) {
                    for (let i = 0; i < this.loyaltyCardItems.length; i++) {
                        let loyaltyCardItem = this.loyaltyCardItems[i];
                        if (loyaltyCardItem && !loyaltyCardItem.isUsed) {
                            loyaltyCardItem.isUsed = true;
                        }
                    }
                }
            };

            return Sale;
    }]);

angular.module('FlexyBeautyApp.services').
    factory('SaleSrv',["$rootScope","$log","ServerSrv","Sale_Resource","Sale","HumanResourceSrv","PhysicalResourceSrv","DayData","UserActionData","SaleData","gettextCatalog","MessageSrv",
        function ($rootScope,$log,ServerSrv,Sale_Resource,Sale,HumanResourceSrv,PhysicalResourceSrv,DayData,UserActionData,SaleData,gettextCatalog,MessageSrv)
        {
            var  saleSrv = {};
            saleSrv.newLoadRef = function(isApplicationLoading, start, step) {
                return new Promise((resolve) => {
                    let saleStart = start || 0;
                    let saleStep = step || 10000;

                    const sales = isApplicationLoading ? Object.values(SaleData.objSales) : SaleData.indexSales;
                    const subSales = sales.slice(saleStart, saleStart + saleStep);
                    subSales.map((sale) => {
                        sale.loadRef(null, isApplicationLoading);
                    });

                    if (subSales.length === step) {
                        resolve(saleSrv.newLoadRef(isApplicationLoading, saleStart + saleStep, saleStep));
                    } else {
                        resolve();
                    }
                });
            };

            saleSrv.loadRef = function(isApplicationLoading)
            {
                if(isApplicationLoading){
                    let sales = SaleData.objSales;
                    for (let key in sales)
                        sales[key].loadRef(null, isApplicationLoading);
                }
                else {
                    var sales = SaleData.indexSales;
                    for (var i=0;i<sales.length;i++)
                        sales[i].loadRef(null, isApplicationLoading);
                }
            };
            saleSrv.save = function(sale,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(saleSrv.saveSync, sale, successFunction, errorFunction);
            };
            saleSrv.saveSync = function(sale,successFunction,errorFunction)
            {
                //$timeout (function () {

                var saleRes = sale.getObjectResource();
                saleRes.$save({}, //no params
                    function (saleRes) {
                        /** @namespace saleRes.salesId */
                        /** @namespace
                         *  saleRes.saleServicesId */
                        /** @namespace saleRes.saleProductsId */
                        try {
                            if (sale.id==null)
                                sale.id = saleRes.id;
                            if (!sale.version || (saleRes.version && saleRes.version > sale.version))
                                sale.version = saleRes.version;
                            if (saleRes.timeCreated)
                                sale.timeCreated = new Date(saleRes.timeCreated);

                            if (saleRes.saleNumber)
                                sale.saleNumber = saleRes.saleNumber;

                            if (saleRes.softV)
                                sale.softV = saleRes.softV;

                            if (saleRes.advanceNumber)
                                sale.advanceNumber = saleRes.advanceNumber;

                            if (saleRes.estimationNumber)
                                sale.estimationNumber = saleRes.estimationNumber;

                            if (saleRes.signatureCode)
                                sale.signatureCode = saleRes.signatureCode;

                            if (saleRes.salesId && saleRes.salesId.length==sale.sales.length)
                                for (var i=0;i< saleRes.salesId.length;i++)
                                    sale.sales[i].id = saleRes.salesId[i];
                            for (var j=0;j< saleRes.saleServices.length;j++)
                            {
                                sale.saleServices[j].setId(saleRes.saleServices[j].id);
                                if (!sale.saleServices[j].version || (saleRes.saleServices[j].version && saleRes.saleServices[j].version > sale.saleServices[j].version))
                                    sale.saleServices[j].version = saleRes.saleServices[j].version;
                                // if dayHr created by transaction : set dayHrId
                            }
                            for (var j=0;j< saleRes.saleProducts.length;j++) {
                                sale.saleProducts[j].setId(saleRes.saleProducts[j].id);
                                if (!sale.saleProducts[j].version || (saleRes.saleProducts[j].version && saleRes.saleProducts[j].version > sale.saleProducts[j].version))
                                    sale.saleProducts[j].version = saleRes.saleProducts[j].version;

                            }

                            if (saleRes.saleCures)
                                for (var j=0;j< saleRes.saleCures.length;j++)
                                {
                                    sale.saleCures[j].setId(saleRes.saleCures[j].id);
                                    if (!sale.saleCures[j].version || (saleRes.saleCures[j].version && saleRes.saleCures[j].version > sale.saleCures[j].version))
                                        sale.saleCures[j].version = saleRes.saleCures[j].version;
                                    if (saleRes.saleCures[j].cureItems)
                                        for (var k=0;k< saleRes.saleCures[j].cureItems.length;k++)
                                        {
                                            sale.saleCures[j].cureItems[k].setId(saleRes.saleCures[j].cureItems[k].id);
                                            if (saleRes.saleCures[j].cureItems[k].cureItemToServiceIds)
                                                for (var l=0;l< saleRes.saleCures[j].cureItems[k].cureItemToServiceIds.length;l++)
                                                    sale.saleCures[j].cureItems[k].cureItemToServices[l].setId(saleRes.saleCures[j].cureItems[k].cureItemToServiceIds[l]);
                                        }
                                }

                            if (saleRes.giftItems)
                                for (var j=0;j< saleRes.giftItems.length;j++)
                                {

                                    sale.giftItems[j].setId(saleRes.giftItems[j].id);
                                    sale.giftItems[j].code = saleRes.giftItems[j].code;
                                    if (!sale.giftItems[j].version || (saleRes.giftItems[j].version && saleRes.giftItems[j].version > sale.giftItems[j].version))
                                        sale.giftItems[j].version = saleRes.giftItems[j].version;


                                }
                            if (saleRes.loyaltyCardItems && saleRes.loyaltyCardItems.length==sale.loyaltyCardItems.length)
                                for (var j=0;j< saleRes.loyaltyCardItems.length;j++)
                                {
                                    sale.loyaltyCardItems[j].id = saleRes.loyaltyCardItems[j].id;
                                    if (!sale.loyaltyCardItems[j].version || (saleRes.loyaltyCardItems[j].version && saleRes.loyaltyCardItems[j].version > sale.loyaltyCardItems[j].version))
                                        sale.loyaltyCardItems[j].version = saleRes.loyaltyCardItems[j].version;

                                }

                            if (saleRes.customer && sale.customer)
                            {
                                sale.customer.setId(saleRes.customer.id);
                                if (!sale.customer.version || (saleRes.customer.version && saleRes.customer.version > sale.customer.version))
                                    sale.customer.version = saleRes.customer.version;

                            }

                            sale.totalLoyaltyPts = saleRes.totalLoyaltyPts;
                            sale.advancePrice = saleRes.advancePrice;
                            sale.site = saleRes.site;
                            sale.hasLoyaltyDiscount = saleRes.hasLoyaltyDiscount;
                            UserActionData.add(saleRes.userAction);
                            //CallBack on success
                            if (successFunction != undefined)
                                successFunction(saleRes);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            var errorMessage = "Erreur inconnue lors de la sauvegarde."
                            if (data.status && data.data )
                            {
                                if (data.status=="409" )
                                {
                                    if (data.data.errorCode == "40900")
                                        errorMessage = "L'heure choisie pour la réservation n'est plus disponible.";
                                }
                            }
                            if (errorFunction != undefined)
                                errorFunction(errorMessage);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            saleSrv.remove = function (sale, successFunction, errorFunction) {
                //Remove directly from model
                ServerSrv.startSavingProcess(saleSrv.removeSync, sale, successFunction, errorFunction);
            };
            saleSrv.removeSync = function (sale, successFunction, errorFunction) {
                //$timeout (function () {

                var saleSrv = new Sale_Resource();
                saleSrv.$remove({id: sale.id}, //params : id
                    function (data) {
                        try {
                            UserActionData.add(data.userAction);

                            if (successFunction != undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction != undefined) {
                                errorFunction(data);
                            }
                        }
                        finally {
                            ServerSrv.endSavingProcess(false, (data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
                //},2000)
            };

            saleSrv.executeTransaction =  function(transaction,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(saleSrv.executeTransactionAsync, transaction, successFunction, errorFunction);
            };
            saleSrv.executeTransactionAsync =  function(transaction,successFunction,errorFunction)
            {
                if (transaction && transaction.objects && transaction.objects.length>0)
                {
                    var transactionResource = new Sale_Resource();
                    transactionResource.sales = [];
                    for (var i=0;i<transaction.objects.length;i++)
                        transactionResource.sales.push(transaction.objects[i].getObjectResource());
                    transactionResource.$saveTransaction({}, //no params
                        function (data) {
                            /** @namespace data.saleServicesId */
                            var success = true;
                            try {
                                var sale;
                                var saleRes;
                                if (data.sales && data.sales!==undefined && transaction.objects.length ==data.sales.length && data.userAction && data.userAction!==undefined) {
                                    for (var i = 0; i < transaction.objects.length; i++)//Consider order must be the same
                                    {
                                        var j;
                                        sale = transaction.objects[i];
                                        saleRes = data.sales[i];
                                        if (sale.id == null)
                                            sale.id = saleRes.id;
                                        if (!sale.version || (saleRes.version && saleRes.version > sale.version))
                                            sale.version = saleRes.version;
                                        if (saleRes.timeCreated)
                                            sale.timeCreated = new Date(saleRes.timeCreated);

                                        if (saleRes.saleNumber)
                                            sale.saleNumber = saleRes.saleNumber;

                                        if (saleRes.softV)
                                            sale.softV = saleRes.softV;

                                        if (saleRes.advanceNumber)
                                            sale.advanceNumber = saleRes.advanceNumber;

                                        if (saleRes.estimationNumber)
                                            sale.estimationNumber = saleRes.estimationNumber;

                                        if (saleRes.signatureCode)
                                            sale.signatureCode = saleRes.signatureCode;

                                        if (sale.booking && saleRes.bookingId == sale.booking.id)  {
                                            sale.booking.version = saleRes.bookingVersion;
                                        }

                                        if (saleRes.salesId && saleRes.salesId.length == sale.sales.length)
                                            for (var i = 0; i < saleRes.salesId.length; i++)
                                                sale.sales[i].id = saleRes.salesId[i];
                                        for (var j = 0; j < saleRes.saleServices.length; j++) {
                                            sale.saleServices[j].setId(saleRes.saleServices[j].id);
                                            if (!sale.saleServices[j].version || (saleRes.saleServices[j].version && saleRes.saleServices[j].version > sale.saleServices[j].version))
                                                sale.saleServices[j].version = saleRes.saleServices[j].version;
                                        }
                                        for (var j = 0; j < saleRes.saleProducts.length; j++) {
                                            sale.saleProducts[j].setId(saleRes.saleProducts[j].id);
                                            if (!sale.saleProducts[j].version || (saleRes.saleProducts[j].version && saleRes.saleProducts[j].version > sale.saleProducts[j].version))
                                                sale.saleProducts[j].version = saleRes.saleProducts[j].version;

                                        }

                                        if (saleRes.saleCures)
                                            for (var j = 0; j < saleRes.saleCures.length; j++) {
                                                sale.saleCures[j].setId(saleRes.saleCures[j].id);
                                                if (!sale.saleCures[j].version || (saleRes.saleCures[j].version && saleRes.saleCures[j].version > sale.saleCures[j].version))
                                                    sale.saleCures[j].version = saleRes.saleCures[j].version;
                                                if (saleRes.saleCures[j].cureItems)
                                                    for (var k = 0; k < saleRes.saleCures[j].cureItems.length; k++) {
                                                        sale.saleCures[j].cureItems[k].setId(saleRes.saleCures[j].cureItems[k].id)
                                                        if (saleRes.saleCures[j].cureItems[k].cureItemToServiceIds)
                                                            for (var l = 0; l < saleRes.saleCures[j].cureItems[k].cureItemToServiceIds.length; l++)
                                                                sale.saleCures[j].cureItems[k].cureItemToServices[l].setId(saleRes.saleCures[j].cureItems[k].cureItemToServiceIds[l]);
                                                    }
                                            }

                                        if (saleRes.giftItems)
                                            for (var j = 0; j < saleRes.giftItems.length; j++) {

                                                sale.giftItems[j].setId(saleRes.giftItems[j].id);
                                                sale.giftItems[j].code = saleRes.giftItems[j].code;
                                                if (!sale.giftItems[j].version || (saleRes.giftItems[j].version && saleRes.giftItems[j].version > sale.giftItems[j].version))
                                                    sale.giftItems[j].version = saleRes.giftItems[j].version;


                                            }
                                        if (saleRes.loyaltyCardItems && saleRes.loyaltyCardItems.length == sale.loyaltyCardItems.length)
                                            for (var j = 0; j < saleRes.loyaltyCardItems.length; j++) {
                                                sale.loyaltyCardItems[j].id = saleRes.loyaltyCardItems[j].id;
                                                if (!sale.loyaltyCardItems[j].version || (saleRes.loyaltyCardItems[j].version && saleRes.loyaltyCardItems[j].version > sale.loyaltyCardItems[j].version))
                                                    sale.loyaltyCardItems[j].version = saleRes.loyaltyCardItems[j].version;

                                            }

                                        if (saleRes.customer && sale.customer) {
                                            sale.customer.setId(saleRes.customer.id);
                                            if (!sale.customer.version || (saleRes.customer.version && saleRes.customer.version > sale.customer.version))
                                                sale.customer.version = saleRes.customer.version;

                                        }

                                        sale.totalLoyaltyPts = saleRes.totalLoyaltyPts;
                                        sale.site = saleRes.site;
                                        sale.hasLoyaltyDiscount = saleRes.hasLoyaltyDiscount;
                                        sale.advancePrice = saleRes.advancePrice;

                                        sale.customerLastname = saleRes.customerLastname;
                                        sale.customerFirstname = saleRes.customerFirstname;
                                        sale.customerAddress = saleRes.customerAddress;
                                        sale.customerZip = saleRes.customerZip;
                                        sale.customerCity = saleRes.customerCity;
                                        sale.shareCapital = saleRes.shareCapital;
                                        sale.greffeCity = saleRes.greffeCity;
                                        sale.juridicForm = saleRes.juridicForm;
                                    }
                                    UserActionData.add(data.userAction);
                                    //CallBack on success
                                    if (successFunction != undefined)
                                        successFunction(data);
                                    success = true;
                                }
                                else {
                                    success = false;
                                    $log.error("Sale.executeTransactionAsync : incorrect return data");

                                }
                            }
                            catch (ex){
                                if (errorFunction !=undefined)
                                    errorFunction(data);
                            }
                            finally {
                                if (success) {
                                    ServerSrv.endSavingProcess(true);
                                }
                                else {
                                    ServerSrv.endSavingProcess(false, 200);
                                }
                            }
                        },
                        function (data) {   //failure
                            //error handling goes here
                            try {
                                if (errorFunction !=undefined)
                                    errorFunction(data);
                            }
                            finally {
                                ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                            }
                        }
                    );

                }
                else
                    ServerSrv.endSavingProcess(true);

            };
            saleSrv.refund =  function(sale,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(saleSrv.refundAsync, sale, successFunction, errorFunction);
            };
            saleSrv.refundAsync = function(sale,successFunction,errorFunction)
            {
                var ress = new Sale_Resource();
                ress.$refund({id:sale.id}, //params
                    function (data) {   //success
                        try {
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure

                        try {
                            //error handling goes here
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    });

            };
            saleSrv.sendMails =  function(sale,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(saleSrv.sendMailsAsync, sale, successFunction, errorFunction);
            };
            saleSrv.sendMailsAsync = function(sale,successFunction,errorFunction)
            {
                var ress = new Sale_Resource();
                ress.$sendMails({id:sale.id}, //params
                    function (data) {   //success
                        try {
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure

                        try {
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    });

            };


            saleSrv.removeLocally =  function(id,resource)
            {
                var sale =  SaleData.getById(id);
                if (sale && sale.version && resource.version && resource.version < sale.version)
                    return null;
                if (sale!=null)
                {
                    if (sale.day)
                        sale.day.removeSale(sale);
                    if (sale.customer)
                        sale.customer.removeSale(sale);
                    sale.isDeleted =  true;
                }
                return sale;
            };
            saleSrv.addLocally =  function(id,resource)
            {
                var sale =  SaleData.getById(id);
                if (sale && sale.version && resource.version && resource.version < sale.version)
                    return null;
                var day = DayData.getById(resource.dayId);
                if (sale!=null) //check if resource already exist inside index (current action could be a 'cancel')
                {
                    if (sale.customer)
                        sale.customer.removeSale(sale);
                    sale.loadObjectProperties(resource);
                }
                else
                {
                    sale = new Sale(resource,day,false, null, false);//dont load salesService (will be done after)
                    sale.id = id;
                }
                sale.loadRef();
                if (day)
                    day.addSale(sale);

                return sale;
            };
            saleSrv.updateLocally =  function(id,resource) {
                let sale =  SaleData.getById(id);
                if(!sale) {
                    MessageSrv.send("error", gettextCatalog.getString("Veuillez recharger l'application afin d'actualiser les données"));
                    console.log("Sale.updateLocally error from userAction - no entity found - Sale ID: " + id);
                    return null;
                }
                if (sale.version && resource.version && resource.version < sale.version)
                    return null;

                let day =  DayData.getById(resource.dayId);
                if (day && sale) {
                    if (sale.day!==day) {
                        sale.day.removeSale(sale);
                        day.addSale(sale);
                    }
                    if (sale.customer)
                        sale.customer.removeSale(sale);
                    sale.loadObject(resource);
                    sale.loadRef();//Will add to customer
                }
                return sale;
            };
            saleSrv.getPreviousVersionInstance =  function(resource)
            {
                var day = DayData.getById(resource.dayId);
                var sale =  new Sale(resource,day,false,true, false);
                return sale;
            };

            return saleSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SaleData',["$log","ModelDataUtil", function ($log,ModelDataUtil)
    {
        var  saleData =
        {
            objSales : {},
            indexSales : []
        };
        saleData.getById =  function(saleId, isApplicationLoading)
        {
            let sale = null;
            if(isApplicationLoading){
                sale = this.objSales[saleId];
            }
            else {
                for (var i = 0; i < this.indexSales.length; i++){
                    if (this.indexSales[i].id === saleId) {
                        sale = this.indexSales[i];
                        break;
                    }
                }
            }
                return sale;
        };

        saleData.getIndexOf =  function(sale)
        {
            if (sale)
                return this.indexSales.indexOf(sale);
            return -1;
        }
        saleData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexSales.length)
                return this.indexSales[index];
            else
                return null;
        }

        saleData.getListByDate =  function(date)
        {
            var sales = [];
            var sale;
            var hasDate;
            var fullYear = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();
            if (date)
                for (var i=0;i<this.indexSales.length;i++)
                {
                    sale = this.indexSales[i];
                    for (var j=0;j<sale.payments.length;j++)
                        if (!hasDate)//deprecated
                            if (!this.indexSales[i].isDeleted && this.indexSales[i].timeCreated &&
                                this.indexSales[i].timeCreated.getFullYear() == fullYear &&
                                this.indexSales[i].timeCreated.getMonth() == month &&
                                this.indexSales[i].timeCreated.getDate() == day)
                                sales.push(this.indexSales[i]);

                }

            return sales;
        }
        saleData.getListByPaymentDate =  function(date)
        {
            var sales = [];
            var sale;
            var hasDate;
            var fullYear = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();
            var match;
            var time;
            if (date)
                for (var i=0;i<this.indexSales.length;i++)
                {
                    match = false;
                    hasDate =false;
                    sale = this.indexSales[i];
                    for (var j=0;j<sale.payments.length &&!match;j++)
                    {
                        time =   sale.payments[j].date.getTime();
                        if (sale.payments[j].date &&  time!=0 && !isNaN(time) )
                        {
                            hasDate = true;
                            match =  (sale.payments[j].date.getFullYear() == fullYear &&
                            sale.payments[j].date.getMonth() == month &&
                            sale.payments[j].date.getDate() == day)
                        }
                        if (!match && !hasDate)//deprecated
                            match = (!this.indexSales[i].isDeleted && this.indexSales[i].timeCreated &&
                            this.indexSales[i].timeCreated.getFullYear() == fullYear &&
                            this.indexSales[i].timeCreated.getMonth() == month &&
                            this.indexSales[i].timeCreated.getDate() == day)
                        if(match)
                            sales.push(this.indexSales[i]);
                    }

                }

            return sales;
        };
        saleData.getListByPaymentDateAndType =  function(date,type)
        {
            var saleAndPayments = [];
            var sale;
            var hasDate;
            var fullYear = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();
            var match;
            var time;
            if (date)
                for (var i=0;i<this.indexSales.length;i++)
                {
                    hasDate =false;
                    sale = this.indexSales[i];
                    if (sale.status=="sold" || sale.status=="advance"|| sale.status=="advanceKeeped")
                        for (var j=0;j<sale.payments.length;j++)
                        {
                            if (sale.payments[j].type==type)
                            {
                                match = false;
                                time =   sale.payments[j].date.getTime();
                                if (sale.payments[j].date &&  time!=0 && !isNaN(time) )
                                {
                                    hasDate = true;
                                    match =  (sale.payments[j].date.getFullYear() == fullYear &&
                                    sale.payments[j].date.getMonth() == month &&
                                    sale.payments[j].date.getDate() == day)
                                }
                                if (!match && !hasDate)//deprecated
                                    match = (!this.indexSales[i].isDeleted && this.indexSales[i].timeCreated &&
                                    this.indexSales[i].timeCreated.getFullYear() == fullYear &&
                                    this.indexSales[i].timeCreated.getMonth() == month &&
                                    this.indexSales[i].timeCreated.getDate() == day);
                                if(match)
                                    saleAndPayments.push({sale : this.indexSales[i], payment : sale.payments[j]});
                            }
                        }

                }

            return saleAndPayments;
        };
        saleData.getPriceByPaymentDateAndType =  function(date,type)
        {
            var price =0;
            var sale;
            var hasDate;
            var fullYear = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();
            var match;
            var time;
            if (date)
                for (var i=0;i<this.indexSales.length;i++)
                {
                    hasDate =false;
                    sale = this.indexSales[i];
                    if (sale.status=="sold" || sale.status=="advance"|| sale.status=="advanceKeeped")
                        for (var j=0;j<sale.payments.length;j++)
                        {
                            if (sale.payments[j].type==type)
                            {
                                match = false;
                                time =   sale.payments[j].date.getTime();
                                if (sale.payments[j].date &&  time!=0 && !isNaN(time) )
                                {
                                    hasDate = true;
                                    match =  (sale.payments[j].date.getFullYear() == fullYear &&
                                    sale.payments[j].date.getMonth() == month &&
                                    sale.payments[j].date.getDate() == day)
                                }
                                if (!match && !hasDate)//deprecated
                                    match = (!this.indexSales[i].isDeleted && this.indexSales[i].timeCreated &&
                                    this.indexSales[i].timeCreated.getFullYear() == fullYear &&
                                    this.indexSales[i].timeCreated.getMonth() == month &&
                                    this.indexSales[i].timeCreated.getDate() == day);
                                if(match)
                                    price+= sale.payments[j].price;
                            }
                        }

                }

            return price;
        };
        saleData.getListByPaymentType =  function(type,status)
        {
            var sales = [];
            var found;
            if (type)
                for (var i=0;i<this.indexSales.length;i++)
                {
                    found = false;
                    if (status==undefined)
                        for (var j=0;j<this.indexSales[i].payments.length && !found;j++)
                        {
                            if (!this.indexSales[i].isDeleted && this.indexSales[i].payments[j].type==type)
                            {
                                sales.push(this.indexSales[i]);
                                found = true;
                            }
                        }
                    else
                        for (var j=0;j<this.indexSales[i].payments.length && !found;j++)
                        {
                            if (this.indexSales[i].status==status && !this.indexSales[i].isDeleted && this.indexSales[i].payments[j].type==type)
                            {
                                sales.push(this.indexSales[i]);
                                found = true;
                            }
                        }

                }

            return sales;
        };
        saleData.getListByDatePeriod =  function(startDate,endDate)
        {
            var sales = [];
            if (startDate && endDate)
                for (var i=0;i<this.indexSales.length;i++)
                    if (!this.indexSales[i].isDeleted && this.indexSales[i].timeCreated.getTime()>=startDate && this.indexSales[i].timeCreated.getTime()<=endDate)
                        sales.push(this.indexSales[i]);
            return sales;
        };
        saleData.getListByStatus =  function(status)
        {
            var sales = [];
            if (status)
                for (var i=0;i<this.indexSales.length;i++)
                    if (!this.indexSales[i].isDeleted && this.indexSales[i].status==status)
                        sales.push(this.indexSales[i]);
            return sales;
        };
        saleData.getOnlineListByStatus =  function(status)
        {
            var sales = [];
            if (status)
                for (var i=0;i<this.indexSales.length;i++)
                    if (!this.indexSales[i].isDeleted && this.indexSales[i].status==status && this.indexSales[i].isCreatedByCustomer)
                        sales.push(this.indexSales[i]);
            return sales;
        };
        saleData.getOnlineListByStatusAndDelivery =  function(status,delivery)
        {
            var sales = [];
            if (status)
                for (var i=0;i<this.indexSales.length;i++)
                    if (!this.indexSales[i].isDeleted && this.indexSales[i].delivery==delivery && this.indexSales[i].isCreatedByCustomer && this.indexSales[i].status==status)
                        sales.push(this.indexSales[i]);
            return sales;
        };

        saleData.add =  function(sale, isApplicationLoading)
        {
            if(isApplicationLoading){
                if(sale && sale.id)
                    this.objSales[sale.id] = sale;
            }
            else{
                //to do add always sorted
                this.indexSales.push(sale);
            }
        };

        saleData.clear =  function()
        {
            saleData.indexSales = [];
            saleData.objSales = {};
        };

        saleData.convertMapToArray = function(keepObject, isNewLoading){
            if (isNewLoading) {
                this.indexSales = ModelDataUtil.convertObjectToArray(this.objSales, this.indexSales);
                if (!keepObject) {
                    this.objSales = {};
                }
            } else {
                this.indexSales = ModelDataUtil.convertMapToArray(this.objSales, this.indexSales);
                this.objSales = null;
            }
        };

        return saleData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/Sale.js